export const roles = {
    adminOnly: ["Administrador"],
    editorOnly: ["Publicador"],
    adminAndEditor: ["Administrador", "Publicador"],
    adminAndEditorRepresentante: ["Administrador", "Publicador", "Representante do Órgão"],
    all: ["Administrador", "Publicador"],
};
